export default {
    CARD: 'card'
};



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarItemTypes.js